module.exports = __webpack_public_path__ + "static/media/Structural Bridge Design.d80b5306.png";